import React, {type PropsWithChildren} from 'react';

import {Button, Icon} from '@albert-io/atomic';

interface Props {
  className?: string;
  disabled?: boolean;
  label?: string;
  onClick: () => void;
}

export default function Grade({
  children,
  className,
  disabled = false,
  label = 'Grade',
  onClick,
  ...rest
}: PropsWithChildren<Props>) {
  return (
    <Button className={className} disabled={disabled} onClick={onClick} type='button' {...rest}>
      <Icon icon='file-pen' iconStyle='light' className='mr-x1' />
      {children ?? label}
    </Button>
  );
}
